/**
 * Mappings spéciaux pour la capitalisation des termes de recherche automobile
 * Utilisé pour formater correctement les noms de marques, modèles et spécifications
 */
export const castMapping = [
    "BMW",
    "CH",
    "GTI",
    "GT",
    "GTB",
    "TB/TS",
    "AMG",
    "AWD",
    "TFSI",
    "GTO",
    "GTS",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII",
    "XIII",
    "XIV",
    "XV",
    "GTC",
    "XC",
    "EC",
    "SL",
    "SLR",
    "EX",
    "RS",
    "RSQ",
    "McLaren",
    "600LT",
];